import { createSelector } from 'reselect';
import _ from 'lodash';

import {
  AUTO_SERVE_OPTIONS,
  SessionTypes,
  INVALID_STUDENT,
} from 'PointOfSale/modules/common/constants';

export const getCurrentProfile = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile');

export const getProfile = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile.profile');

export const getProfileIdSeed = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile.profile.IdSeed');

export const getProfileFullName = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile.profile.FullName');

export const getProfileSymbolIndicator = state =>
  _.get(
    state,
    'PointOfSaleState.serving.currentProfile.profile.symbolIndicator'
  );

export const getIsInvalidStudentSelected = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile.profile.Id') ===
  INVALID_STUDENT.Id;

export const getSessions = state =>
  _.get(state, 'PointOfSaleState.servingOptions.sessions');

export const getActiveSession = state =>
  _.get(state, 'PointOfSaleState.servingOptions.activeSession');

export const hasSessionType = (state, type) => {
  const sessions = getSessions(state);
  const session = _.get(sessions, type);
  if (session && !_.isEmpty(session)) {
    return true;
  }
  return false;
};

export const hasQueueSession = state =>
  hasSessionType(state, SessionTypes.Queue);

export const hasTeacherSession = state =>
  hasSessionType(state, SessionTypes.Teacher);

export const hasMealCounterSession = state => {
  const sessions = getSessions(state);
  return (
    _.get(sessions, [SessionTypes.Queue, 'queueType']) ===
    AUTO_SERVE_OPTIONS.MealCounter
  );
};

export const getIsCurrentSessionMealCounter = state => {
  return (
    getActiveSession(state) === SessionTypes.Queue &&
    hasMealCounterSession(state)
  );
};

export const getQuickServeItem = createSelector(
  [getSessions, getActiveSession],
  (sessions, activeSession) => {
    return _.get(sessions, [activeSession, 'quickServeItem'], {});
  }
);

export const getHasQuickServeItem = state => {
  const qsi = getQuickServeItem(state);
  return !(_.isNil(qsi) || _.isEmpty(qsi));
};

export const getProhibitedItems = state =>
  _.get(
    state,
    'PointOfSaleState.serving.currentProfile.profile.ProhibitedItems',
    []
  );

export const getBalance = state =>
  _.get(state, 'PointOfSaleState.serving.currentProfile.profile.Balance');

export const getPreviousAmountPaid = state =>
  _.get(state, 'PointOfSaleState.serving.previousAmountPaid', 0);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/state/selectors.js